const Webinar = () => {
	jQuery('body').on('click', '.webinar-video-link', function (event) {
		event.preventDefault();
		if (!jQuery('.webinar-video-popup__wrapper').hasClass('active')) {
			const iframe = jQuery(
				'.webinar-video-popup__wrapper .webinar-video-frame__iframe-embed'
			);
			iframe[0].src += '?autoplay=1';
			jQuery('.webinar-video-popup__wrapper').addClass('active');
		}
	});
	jQuery('body').on('click', '.webinar-video-popup__close', function () {
		if (jQuery('.webinar-video-popup__wrapper').hasClass('active')) {
			const iframe = jQuery(
				'.webinar-video-popup__wrapper .webinar-video-frame__iframe-embed'
			);
			const newSource = iframe.attr('src').replace('?autoplay=1', '');
			iframe.attr('src', newSource);
			jQuery('.webinar-video-popup__wrapper').removeClass('active');
		}
	});
};

export default Webinar;
